export default {
    title: "地址验证",
    header: "@:views.address.verified.title",
    message: "感谢您验证您的地址。您现在可以在下订单时选择此地址作为送货地址。",
}